import Application from "../../Application";
import MenuItemsPresenter, {
  IMenuItemsPresenter
} from "../../presenter/menu/MenuItemsPresenter";
import GetAllRootMenuItemsInteractor from "./GetAllRootMenuItemsInteractor";

export default class ShowMenuItemsInteractor {
  private application: Application;
  private output?: IMenuItemsPresenter;

  constructor(application) {
    this.application = application;
  }

  async getAllMenuItems() {
    return await this.application.container
      .resolve<GetAllRootMenuItemsInteractor>("getAllRootMenuItems")
      .execute();
  }

  execute() {
    this.output = MenuItemsPresenter({
      application: this.application,
      initialState: {
        menuItems: [],
        availableMenuItems: []
      }
    });

    this.getAllMenuItems().then(this.output && this.output.setMenuItems);

    return this.output;
  }
}
